import React from 'react'

function Chat() {
  return (
    <div>Chats</div>
  )
}

export default Chat